var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-sm text-white mr-2 ml-md-2 mr-md-0",class:_vm.classes,attrs:{"href":"#","rounded":_vm.rounded}},[(_vm.icon)?_c('i',{class:( _obj = {
      'mr-1': _vm.label && _vm.label != ''
    }, _obj['icon-' + _vm.icon] = true, _obj )}):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }